"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_rdf_serialize_1 = require("@comunica/bus-rdf-serialize");
/**
 * A comunica Jsonld RDF Serialize Actor.
 */
class ActorRdfSerializeJsonLd extends bus_rdf_serialize_1.ActorRdfSerializeFixedMediaTypes {
    constructor(args) {
        super(args);
        this.jsonLd = require('jsonld')();
    }
    async runHandle(action, mediaType, context) {
        const quadsArray = await require('arrayify-stream')(action.quads);
        const jsonLines = (await this.jsonLd.fromRDF(quadsArray, { useNativeTypes: true }))
            .map((jsonObject) => JSON.stringify(jsonObject, null, this.jsonStringifyIndentSpaces));
        return { data: require('streamify-string')(`[${jsonLines.join(',')}]`) };
    }
}
exports.ActorRdfSerializeJsonLd = ActorRdfSerializeJsonLd;
//# sourceMappingURL=ActorRdfSerializeJsonLd.js.map